// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"CleanKindItems--next-sr-only--1PbUShg","textPlaceholder":"CleanKindItems--textPlaceholder--1iP76gN","spaceBetween":"CleanKindItems--spaceBetween--1OJV50e"};